<template>
  <div>
    <el-dialog
        title="详情"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="handleClose"
        :close-on-click-modal="false"
        center
    >
      <ul class="content-wrap">
        <li>
          <div class="label">订单编号：</div><div class="content">{{info.orderId||'暂无'}}</div>
        </li>
        <li>
          <div class="label">名称：</div><div class="content">{{info.orderDescribe||'暂无'}}</div>
        </li>
        <li>
          <div class="label">用户手机号：</div><div class="content">{{info.phoneNumber||'暂无'}}</div>
        </li>
        <li>
          <div class="label">创建时间：</div><div class="content">{{info.orderCreateTime||'暂无'}}</div>
        </li>
        <li>
          <div class="label">支付时间：</div><div class="content">{{
              info.orderPayStatus == (0 || -1) ? '--' : (info.orderPayTime||'暂无')
            }}</div>
        </li>
        <li>
          <div class="label">订单价格(元)：</div><div class="content">{{(info.cashFee / 100).toFixed(2)}}</div>
        </li>
        <li>
          <div class="label">汇付识别码：</div><div class="content">{{info.code||'暂无'}}</div>
        </li>
        <li>
          <div class="label">购买状态：</div><div class="content">{{orderPayStatus(info.orderPayStatus)}}</div>
        </li>
        <li>
          <div class="label">支付方式：</div><div class="content">{{orderPayType(info.orderPayType)}}</div>
        </li>
        <li>
          <div class="label">管理员手机号：</div><div class="content">{{info.yzbAdminTel||'暂无'}}</div>
        </li>
        <li>
          <div class="label=">备注：</div><el-input type="textarea" class="content" v-model="info.notes" :rows="5"></el-input> <el-button style="margin-left:5px; height:35px" type="primary" @click="saveAction">保存</el-button>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "orderDetailDialog",
  data() {
    return {
      dialogVisible: false,
      orderId: -1,
      info: {}
    }
  },
  methods: {
    orderPayStatus(type) {
      if (type == 0) return '未支付'
      else if (type == 1) return '已支付'
      else if (type == 2) return '订单失效'
      else if (type == 3) return '部分支付'
      else return '-'
    },
    orderPayType(type) {
      if (type == 1) return '微信app'
      else if (type == 2) return '支付宝app'
      else if (type == 3) return '转账'
      else if (type == 4) return '余额支付'
      else if (type == 5) return 'IOS支付'
      else if (type == 6) return '微信扫码支付'
      else if (type == 7) return '微信jsapi支付'
      else if (type == 8) return '支付宝支付'
      else if (type == 9) return  '对公转账'
      else if (type == 12) return  '后台开通'
      else if (type == 13) return 'H5微信'
      else if (type == 14) return 'H5支付宝'
      else if (type == 15) return '微信浏览器下的jsapi支付'
      else '未知'
    },
    open(id) {
      this.orderId = id
      this.dialogVisible = true
      this.getOrderDetail()
    },
    // close() {
    //   this.$emit('update')
    //   this.dialogVisible = false
    //
    // },
    handleClose() {
      this.$emit('update')
      this.dialogVisible = false
    },

    // 获取订单详情
    async getOrderDetail() {
      let res = await this.$request.getOrderDetail({id: this.orderId})
      if (res.status === 200) {
        this.info = res.data
        await this.$store.dispatch('changeOrderNum')
      }
    },
    async saveAction(){
      let res = await this.$request.updateNotes({id: this.info.id+"", notes: this.info.notes});
      if (res.status == 200){
        console.debug('----------');
        this.$message({ type: 'success', message: res.message });
      }else{
        this.$message({ type: 'error', message: res.message });
      }
    },
  }
}
</script>

<style lang="less" scoped>
.content-wrap {
  li {
    display: flex;
    min-height: 35px;
    line-height: 35px;
    .label {
      width: 120px;
      text-align: right;
      margin-right: 4px;
    }
    .content {
      flex: 1;
    }
  }
}
</style>